module.exports = __webpack_public_path__ + "img/jpeg.ad566271.png";